export const cTipoVenta = {
    CREDITO: 1,
    CONTADO: 2
};